export const flexDirectionOptions = [
  { label: "Слева направо", value: 'row' },
  { label: "Справа налево", value: 'row-reverse' },
  { label: "Сверху вниз", value: 'column' },
  { label: "Снизу вверх", value: 'column-reverse' },
];

export const justifyContentOptions = [
  { label: "По началу", value: 'flex-start' },
  { label: "По концу", value: 'flex-end' },
  { label: "По центру", value: 'center' },
  { label: "Равные промежутки между элементами", value: 'space-between' },
  { label: "Равные промежутки вокруг элементов", value: 'space-around' },
  { label: "Равные промежутки между и вокруг элементов", value: 'space-evenly' },
];

export const alignItemsOptions = [
  { label: "Растянуть на всю высоту", value: 'stretch' },
  { label: "Выровнять по началу", value: 'flex-start' },
  { label: "Выровнять по концу", value: 'flex-end' },
  { label: "По центру", value: 'center' },
  { label: "По базовой линии текста", value: 'baseline' },
];

export const flexWrapOptions = [
  { label: "Без переноса", value: 'nowrap' },
  { label: "Перенос", value: 'wrap' },
  { label: "Обратный перенос", value: 'wrap-reverse' },
];
